import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { SettingsProvider } from 'src/app/services/settings';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  // comon variables
  userPermissions: any = {};
  newPayment: any = {};
  newOrganization: any = {};
  newShop: any = {};
  latLong2: any = {};
  newProduct: any = {};
  newDebt: any = {};
  types:any = [
    { name: 'POS', value: 'pos' },
    { name: 'Papel', value: 'paper' },
    { name: 'Otros', value: 'others' },
  ];
  statusAsset:any = [
    { name: 'Disponible', value: 'available' },
    { name: 'Asignado', value: 'assigned' },
    { name: 'Dañado', value: 'damaged' },
    { name: 'Vendido', value: 'sold' },
    { name: 'Devuelto', value: 'returned' },
    { name: 'Perdido', value: 'lost' },
  ];
  genders:any = [
    { name: 'Hombre', value: 'MALE' },
    { name: 'Mujer', value: 'FEMALE' },
    { name: 'Otro', value: 'NOT_KNOWN' },
    { name: 'No aplica', value: 'NOT_APPLICABLE' },
  ];
  status:any = [
  { name: 'Pendiente', value: 'pending' },
  { name: 'Activo', value: 'active' },
  { name: 'Inactivo', value: 'inactive' },
  { name: 'Cancelado/Anulado', value: 'cancelled' },
]
  debtStatuses: any = [
    { name: 'Pendiente', value: 'active' },
    { name: 'Pagado', value: 'inactive' },
    { name: 'Bloqueado', value: 'blocked' },
  ]
  userStatuses: any = [
    { name: 'Normal', value: 'normal' },
    { name: 'Preguntar contraseña', value: 'ask_password' },
    { name: 'Confirmacíon pendiente', value: 'pending_confirmation' },
    { name: 'Baneado', value: 'banned' },
  ]
  charges: any = [
    {name: 'Diario', value: 'daily'},
    // {name: 'Semanal', value: 'weekly'},
    {name: 'Mensual', value: 'monthly'},
    {name: 'Una vez', value: 'one-time'},
  ]
  business_types: any = [
    {name: 'Pyme', value: 'Pyme'},
    {name: 'Micro', value: 'Micro'},
    {name: 'Corporate', value: 'Corporate'}
  ]
  society_types: any = [
    {name: 'Persona Natural', value: 'NAT'},
    {name: 'Empresa Unipersonal', value: 'UNIP'},
    {name: 'Soc. de Responsabilidad Limitada', value: 'SRL'},
    {name: 'Sociedad Anónima', value: 'SA'},
  ]
  bank_account_types: any = [
    {name: 'Ahorros', value: 'ahorros'},
    {name: 'Corriente', value: 'comun'},
  ]
  type_branchs: any = [
    {name: 'Normal', value: 'normal'},
    {name: 'Profesional', value: 'pro'},
  ]
  providerTypes: any = [
    {name: 'Tarifa plana', value: 'flat_fee'},
    {name: 'Porcentaje', value: 'percentage'},
    {name: 'Cuotas', value: 'credit'},
    {name: 'Cantidad', value: 'quantity'},
  ]
  updateMap$ = new BehaviorSubject<boolean>(false);
  logOut$ = new BehaviorSubject<boolean>(false);
  refreshUserPermissions$ = new BehaviorSubject<boolean>(false);
  eventSetCustomer$ = new BehaviorSubject<number>(0);
  eventSetDebt$ = new BehaviorSubject<number>(0);

  //functions

  getDate(){
    var date = new Date();
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();

    if(Number(year) < 10){
      year = '0' + year;
    }
    if(Number(month) < 10){
      month = '0' + month;
    }
    if(Number(day) < 10){
      day = '0' + day;
    }

    return `${year}-${month}-${day}`
  }

  transformDate(dateToConvert: string){
    var date = new Date(dateToConvert);
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();

    if(Number(year) < 10){
      year = '0' + year;
    }
    if(Number(month) < 10){
      month = '0' + month;
    }
    if(Number(day) < 10){
      day = '0' + day;
    }

    return `${day}-${month}-${year}`
  }

  getUrl(): string{
    return SettingsProvider.getUrlOnly()
  }

  converToFormData( form: FormGroup, formData: FormData){
    Object.keys(form.controls).forEach( key => {
      formData.append(`${key}`, form.get(`${key}`).value);
    })
  }
  converObjectToFormData( object: Object, formData: FormData){
    Object.keys(object).forEach( key => {
      if(object[`${key}`] != null){
        formData.append(`${key}`, object[`${key}`]);
      }
    })
  }

  setFields(obj: any, fields: string[], innerFields? : string[]){

    var newArray: any = [];
    fields.forEach(element => {
      if (element in obj){
        if(innerFields != undefined){
          innerFields.forEach(elementInner => {
            if(obj[element][elementInner] != null){
              newArray.push(obj[element][elementInner]);
            }else{
              newArray.push(obj[element]);
            }
          });
        }else{
          newArray.push(obj[element]);
        }
      }
    });
    return JSON.stringify(newArray);
  }

  validateForm(form: FormGroup){
    for(let i in form.controls)
      form.controls[i].markAsDirty();
  }

  getLastPath(path: string) :string{
    return path?.split('/')[path?.split('/').length - 1]
  }

  objectEmpty(object: object){
    var empty: boolean = true;

    if(object != undefined){
      if(Object.keys(object).length != 0){
        empty = false;
      }
    }
    return empty;
  }

  getColorStyle(color: string){
    var colorToReturn = '#000';
    if(color != undefined){
      colorToReturn = color;
    }
    return `color: ${colorToReturn};`;
  }

  getBackgroundColorStyle(color: string){
    var colorToReturn = '#000';
    if(color != undefined){
      colorToReturn = color;
    }
    return `background-color: ${colorToReturn};`;
  }

  resetFields(form: FormGroup){
    for(let i in form.controls){
      form.controls[i].setValue('');
      form.controls[i].markAsPristine();
    }
  }

  avoidEmptyFields(form: FormGroup): any{
    var fieldsToReturn: any = form.value;
    Object.keys(form.controls).forEach(key => {
      const abstractControl: any = form.controls[key];
      if(abstractControl.value == ''){
        delete fieldsToReturn[`${key}`];
      }
    });
    return fieldsToReturn;
  }

  avoidEmptyFieldsJson(object: object): any{
    var fieldsToReturn: any = object;
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        if(object[key] === '' || object[key].length === 0){
          delete fieldsToReturn[`${key}`];
        }
      }
    }
    return fieldsToReturn;
  }

  objectPropertyOut(array: any[], compare: any[]){
    var arrayToReturn: any[] = [];
    array.forEach(element => {
      var fieldToOut: any;
      compare.forEach(elementInner => {
        if(elementInner.field in element){
          fieldToOut = { value: element[elementInner.field][elementInner.fieldToOut], name: elementInner.fieldToOut};
        }
      });
      var objectToReturn: any = {
        ...element,
      };
      objectToReturn[`${fieldToOut.name}`] = fieldToOut.value;
      arrayToReturn.push(objectToReturn);
    });
    return arrayToReturn;
  }

  filterSelectedFields(array: any, selectedFields: string[]){
    var newArray: any = [];
    array.forEach(element => {
      var keys = Object.keys(element);
      var newObject: any = {};
      selectedFields.forEach(selectedElement => {
        if(keys.indexOf(selectedElement) > -1){
          newObject[`${selectedElement}`] = element[`${selectedElement}`];
        }
      });
      newArray.push(newObject);
    });

    return newArray;
  }

  checkRoute(userPermissions: any){
    var route = '';
    var flag = false;
    for (const key in userPermissions) {
      if (Object.prototype.hasOwnProperty.call(userPermissions, key)) {
        const element = userPermissions[key];
        if(element.length > 0 && flag === false){
          switch (key) {
            case 'commercial_agreements':
              route = 'trade-agreements';
            break;
            case 'due_payments':
              route = 'charges';
            break;
            case 'invoices':
              route = 'invoices';
            break;
            case 'organizations':
              route = 'business';
            break;
            case 'payments':
              route = 'payments';
            break;
            case 'permissions':
              route = 'permissions';
            break;
            case 'products':
              route = 'products'
            break;
            case 'objectives':
              route = 'objectives'
            break;
            case 'roles':
              route = 'roles';
            break;
            case 'users':
              route = 'users';
            break;
          }
        }

        if (route != '') {
          flag = true;
        }

      }
    }
    this.router.navigate(['/dashboard/'+route]);
  }

  setUserPermissions(){
    var permissionsInner: any = [];
    var commercial_agreements:any = [];
    var payments:any = [];
    var due_payments:any = [];
    var invoices:any = [];
    var products:any = [];
    var objectives:any = [];
    var organizations:any = [];
    var organizations_linkser:any = [];
    var users:any = [];
    var roles:any = [];
    var permissions:any = [];
    var assets:any = [];
    var asset_types:any = [];
    var asset_requests:any = [];

    permissionsInner = JSON.parse(localStorage.getItem('auth')).pm.split(',') || [];
    permissionsInner.forEach(permission => {
      if(permission.includes('commercial_agreements')){
        commercial_agreements.push(permission.split('.')[1]);
      }
      if(permission.includes('payments') && !permission.includes('due_payments')){
        payments.push(permission.split('.')[1]);
      }
      if(permission.includes('due_payments')){
        due_payments.push(permission.split('.')[1]);
      }
      if(permission.includes('invoices')){
        invoices.push(permission.split('.')[1]);
      }
      if(permission.includes('products')){
        products.push(permission.split('.')[1]);
      }
      if(permission.includes('objectives')){
        objectives.push(permission.split('.')[1]);
      }
      if(permission.includes('organizations')){
        organizations.push(permission.split('.')[1]);
      }
      if(permission.includes('organizations_linkser')){
        organizations_linkser.push(permission.split('.')[1]);
      }
      if(permission.includes('users')){
        users.push(permission.split('-')[1]);
      }
      if(permission.includes('roless')){
        roles.push(permission.split('-')[1]);
      }
      if(permission.includes('permissions')){
        permissions.push(permission.split('-')[1]);
      }
      if(permission.includes('asset_types')){
        asset_types.push(permission.split('.')[1]);
      }else if(permission.includes('asset_requests')){
        asset_requests.push(permission.split('.')[1]);
      }else if(permission.includes('assets')){
        assets.push(permission.split('.')[1]);
      }
    });

    this.userPermissions.commercial_agreements = commercial_agreements;
    this.userPermissions.payments = payments;
    this.userPermissions.due_payments = due_payments;
    this.userPermissions.invoices = invoices;
    this.userPermissions.products = products;
    this.userPermissions.objectives = objectives;
    this.userPermissions.organizations = organizations;
    this.userPermissions.users = users;
    this.userPermissions.roles = roles;
    this.userPermissions.organizations_linkser = organizations_linkser;
    this.userPermissions.permissions = permissions;
    this.userPermissions.assets = assets;
    this.userPermissions.asset_types = asset_types;
    this.userPermissions.asset_requests = asset_requests;
  }

  constructor(private router: Router) {
    if(JSON.parse(localStorage.getItem('auth')) != null){
      if(Object.keys(JSON.parse(localStorage.getItem('auth'))).indexOf('pm') >= 0){
        // console.log(Object.keys(JSON.parse(localStorage.getItem('auth'))).indexOf('pm'));
        this.setUserPermissions();
      }
    }


    this.refreshUserPermissions$.subscribe(data => {
      if(data){
        this.setUserPermissions();
      }
    });
  }
}
